.card {
  border-style: solid;
  border-radius: var(--tuna-shape-radius-md);
  cursor: pointer;
  padding: 16px;
}

.cardHeader {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 8px;
}
